export default __webpack_public_path__ + "static/media/attention.db8173bd.png";